import { useContext, useMemo } from 'react'
import { ScenarioStatesProviderContext } from '../providers/StatesProvider'
import { SatelliteGroupType } from '../../types'
import { highlightGroupSatellite } from '../utils/viewer-packets'
import { isEmpty } from 'lodash'
import useTimelineFilter from './useTimelineFilter'
import { ScheduleTaskType } from '../utils/scenario-types'

const useSelectedGroupSatellite = () => {
    const context = useContext(ScenarioStatesProviderContext)
    if (context === undefined) {
        throw new Error('useScenarioResponse must be used within a Scenario States Provider')
    }

    const { resetTimelineFilter } = useTimelineFilter()
    const { formData, selectedGroupSatellite, setSelectedGroupSatellite, viewer, scenarioBaseData } = context
    const schedule = useMemo(() => formData?.assets?.schedule?.data || {} as Record<string, ScheduleTaskType[]>, [formData?.assets?.schedule?.data])
    const allGroups = useMemo(() => scenarioBaseData.allGroups, [scenarioBaseData.allGroups])

    const getSatelliteColor = () => {
        const satColor: { [satId: string]: string } = {}
        allGroups.map(group => group.satellites.map(sat => {
            satColor[sat.uniqueId] = group.color
        }))
        return satColor
    }
    const satellitesColor = useMemo(() => getSatelliteColor(), [allGroups])

    const highlightGroup = (satelliteId: string) => {
        if (isEmpty(satellitesColor)) return
        highlightGroupSatellite(viewer, satellitesColor, satelliteId)
    }

    const onSelectSatellite = (satelliteId: string) => {
        setSelectedGroupSatellite((prev) => ({
            ...prev!,
            satelliteId
        }))
        resetTimelineFilter(schedule, satelliteId)
        highlightGroup(satelliteId)
    }
    const onSelectGroup = (group: SatelliteGroupType) => {
        const satelliteId = group.satellites[0].satelliteId
        setSelectedGroupSatellite({
            groupId: group.satelliteGroupId,
            satelliteId: satelliteId
        })
        resetTimelineFilter(schedule, satelliteId)
        highlightGroup(satelliteId)
    }
    return { selectedGroupSatellite, setSelectedGroupSatellite, onSelectGroup, onSelectSatellite }
}

export default useSelectedGroupSatellite